import { AnyAction } from 'redux'
import { createAction } from 'redux-actions'
import { ThunkDispatch } from 'redux-thunk'
import { message } from 'antd'
import { RootState } from '../../reducers'
import { post, url } from '../../../javascripts/http'
import { InstitutionService } from '../../../api/sennotech/scanner/v2/institution'
import { ObjectStorageService } from '../../../api/sennotech/scanner/v2/object_storage'

const institutionService = new InstitutionService(url, post);
const objectStorageService = new ObjectStorageService(url, post);

export const actionSetAnimation = createAction('SET_ANIMATION');
export const actionSetAdBoard = createAction('SET_AD_BOARD');
export const actionAddAd = createAction('ADD_AD');
export const actionRemoveAd = createAction('REMOVE_AD');
export const actionGetAnimation = createAction('GET_ANIMATION');
// 上传通用方法
const uploadFile = async (file: File, prefix: string) => {
  // 获取上传预签名URL
  const presignedRes = await objectStorageService.getCosPresigned({
    fileNameSuffix: file.name.split('.').pop() || ''
  });

  // 使用fetch上传文件
  const uploadRes = await fetch(presignedRes.presignedUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type
    }
  });

  if (!uploadRes.ok) throw new Error('上传失败');
  return presignedRes.key;
};

// 设置加载动画
export const actionSetLoadingAnimation = (file: File) => {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
    try {
      const { orgInfo } = getState().user;
      const key = await uploadFile(file, 'animations');
      
      const animation = await institutionService.setLoadingAnimation({
        institutionId: orgInfo.id,
        resourceKey: key,
        resourceType: file.type.includes('gif') ? 'gif' : 'video'
      });

      dispatch(actionSetAnimation(animation));
      message.success('动画上传成功',6);
    } catch (error) {
      message.error('动画上传失败',6);
    }
  };
};
export const actionGetLoadingAnimation = () => {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
    try {
      const { orgInfo } = getState().user;
      const animation = await institutionService.getLoadingAnimation({
        institutionId: orgInfo.id
      });
      dispatch(actionSetAnimation(animation));
    } catch (error) {
      message.error('获取加载动画失败',6);
    }
  };
};

// 获取广告看板
export const actionGetAdBoard = () => {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
    try {
      const { orgInfo } = getState().user;
      const board = await institutionService.getAdvertisementBoard({
        institutionId: orgInfo.id
      });
      dispatch(actionSetAdBoard(board));
    } catch (error) {
      message.error('获取广告看板失败',6);
    }
  };
};

// 创建广告
export const actionCreateAdvertisement = (file: File) => {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
    try {
      const { orgInfo } = getState().user;
      const key = await uploadFile(file, 'ads');
      
      const ad = await institutionService.createAdvertisement({
        institutionId: orgInfo.id,
        resourceKey: key,
        resourceType: file.type.includes('gif') ? 'gif' : 'video'
      });

      dispatch(actionAddAd(ad));
      message.success('广告上传成功',6);
    } catch (error) {
      message.error('广告上传失败',6);
    }
  };
};

// 删除广告
export const actionDeleteAdvertisement = (adId: number) => {
  return async (dispatch: ThunkDispatch<RootState, null, AnyAction>) => {
    try {
      await institutionService.deleteAdvertisement({ id: adId });
      dispatch(actionRemoveAd(adId));
      message.success('广告删除成功',6);
    } catch (error) {
      message.error('广告删除失败',6);
    }
  };
};